export function AppsPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold text-secondary-900 dark:text-white">
            Mes Applications
          </h2>
          <p className="text-sm text-secondary-500">
            Gérez vos applications no-code
          </p>
        </div>
        <button className="rounded-lg bg-primary-500 px-4 py-2 text-sm font-medium text-white hover:bg-primary-600">
          Nouvelle Application
        </button>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[
          { name: 'Gestion RH', status: 'active', entities: 5, workflows: 3 },
          { name: 'Permis de Construire', status: 'active', entities: 8, workflows: 4 },
          { name: 'Réclamations Citoyens', status: 'draft', entities: 3, workflows: 2 },
        ].map((app) => (
          <div
            key={app.name}
            className="rounded-xl border border-secondary-200 bg-white p-6 dark:border-secondary-800 dark:bg-secondary-900"
          >
            <div className="flex items-center justify-between">
              <h3 className="font-semibold text-secondary-900 dark:text-white">{app.name}</h3>
              <span
                className={`rounded-full px-2 py-1 text-xs font-medium ${
                  app.status === 'active'
                    ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                    : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
                }`}
              >
                {app.status === 'active' ? 'Actif' : 'Brouillon'}
              </span>
            </div>
            <div className="mt-4 flex gap-4 text-sm text-secondary-500">
              <span>{app.entities} entités</span>
              <span>{app.workflows} workflows</span>
            </div>
            <div className="mt-4 flex gap-2">
              <button className="flex-1 rounded-lg border border-secondary-200 px-3 py-2 text-sm font-medium text-secondary-700 hover:bg-secondary-50 dark:border-secondary-700 dark:text-secondary-300 dark:hover:bg-secondary-800">
                Modifier
              </button>
              <button className="flex-1 rounded-lg bg-primary-500 px-3 py-2 text-sm font-medium text-white hover:bg-primary-600">
                Ouvrir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
